import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authService: AuthService
    ) { }

    async canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        const isAuthenticated = this.authService.isAuthenticated();
        
        if (isAuthenticated) {
            return true;
        }
        
        // Store the attempted URL for redirecting after login
        this.authService.setRedirectUrl(state.url);
        
        // Try silent login first
        if (this.authService.tryUseStoredAccount()) {
            return true;
        }
        
        // If no stored account, redirect to login
        await this.authService.loginRedirect();
        return false;
    }
} 